import { render, staticRenderFns } from "./compareKesehatan.vue?vue&type=template&id=d42e87dc&"
import script from "./compareKesehatan.vue?vue&type=script&lang=ts&"
export * from "./compareKesehatan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports